/* eslint-disable */
import { getMaterials, getNews } from '../../api/materials';
import * as C from './constants';

export function loadNews(limit = 7, page = 1) {
    return {
        type: "PROMISE",
        actions: [
            C.START_LOAD_NEWS,
            C.FINISH_LOAD_NEWS,
            C.ERROR_LOAD_NEWS
        ],
        promise: getNews(limit, page)
    }
}


export function loadMaterials(limit = 9, page = 1) {
    return {
        type: "PROMISE",
        actions: [
            C.START_LOAD_MATERIALS,
            C.FINISH_LOAD_MATERIALS,
            C.ERROR_LOAD_MATERIALS
        ],
        promise: getMaterials(limit, page)
    }
}



// WEBPACK FOOTER //
// ./src/models/materials/actions.js